import config from '../config';

export default function getRepositoryActivity(repositoryId) {
    return fetch(`${config.github.apiBaseURL}/repos/${repositoryId}/stats/commit_activity`);
}